import axios from 'axios';
import { getAuthHeaders } from '../utils/authUtils';

class StageTransitionAnalyticsService {
    /**
     * Fetch aggregated stage-transition timing grouped by language + video-duration bucket.
     *
     * @param {Object} opts
     * @param {string} [opts.contentType='ALL']      'VIDEO' | 'TEXT_FILE' | 'ALL'
     * @param {string} [opts.language='']            filter to one language, or '' for all
     * @param {string} [opts.dateRange='last30days'] 'last7days' | 'last30days' | 'last90days' | 'all'
     * @param {string} [opts.folderPath='']          optional folder prefix (videos only)
     */
    async getAnalytics({ contentType = 'ALL', language = '', dateRange = 'last30days', folderPath = '' } = {}) {
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL || ''}/api/v1/analytics/stage-transitions`,
            {
                headers: getAuthHeaders(true),
                params: { contentType, language, dateRange, folderPath },
            },
        );
        return response.data;
    }

    /**
     * Fetch raw per-item records for scatter-plot use.
     * Same filters as getAnalytics().
     */
    async getRaw({ contentType = 'ALL', language = '', dateRange = 'last30days', folderPath = '' } = {}) {
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL || ''}/api/v1/analytics/stage-transitions/raw`,
            {
                headers: getAuthHeaders(true),
                params: { contentType, language, dateRange, folderPath },
            },
        );
        return response.data;
    }

    /** Format a duration in milliseconds as a human-readable string. */
    formatDuration(ms) {
        if (ms == null || ms <= 0) return '—';
        const totalMinutes = Math.round(ms / 60000);
        if (totalMinutes < 60) return `${totalMinutes}m`;
        const hours = Math.floor(totalMinutes / 60);
        const mins  = totalMinutes % 60;
        if (hours < 24) return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
        const days  = Math.floor(hours / 24);
        const hrs   = hours % 24;
        return hrs > 0 ? `${days}d ${hrs}h` : `${days}d`;
    }
}

export default new StageTransitionAnalyticsService();
